var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item flex"},[_c('div',{staticClass:"content-item-label"},[_vm._v(" 转载作者 ")]),_c('el-input',{staticClass:"item-input",attrs:{"placeholder":"请输入转载作者出处...","disabled":_vm.reprintedDisabled},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }